import { computed } from 'vue'

import { isHtmlContent, sanitizeHtml } from '@/6_shared/utils/sanitizeHtml'
import { formatText } from '@/6_shared/utils/formatText'

/**
 * Composable for safely displaying user-generated content
 * Handles both HTML (from WYSIWYG editors) and markdown/plain text
 *
 * @param {Ref<string>} content - Reactive reference to content string
 * @returns {ComputedRef<string>} Sanitized HTML string safe for v-html
 */
export function useFormattedContent(content) {
  return computed(() => {
    if (!content.value) return ''

    // Check if it's HTML content from a WYSIWYG editor
    if (isHtmlContent(content.value)) {
      return sanitizeHtml(content.value)
    }

    // Otherwise, it's markdown/plain text - convert to HTML
    return formatText(content.value)
  })
}
